import React from 'react';

import { AuctionCard } from './AuctionCard.component';
import styles from './LiveStreamCard.module.css';

interface Props {
  livestream: string;
  title: string;
  description: string;
}

export const LiveStreamCard: React.FC<Props> = props => {
  return (
    <AuctionCard>
      <div className={styles.liveVideo}>
        <iframe
          className={styles.livestream}
          src={props.livestream}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title="Embedded youtube"
        />
      </div>
      <div className={styles.live}>
        <svg height="10" width="10">
          <circle cx="5" cy="5" r="2" fill="red" />
        </svg>
        live
      </div>
      <div className={styles.LiveStreamDetails}>
        <div className={styles.title}>{props.title}</div>
        <div className={styles.description}>{props.description}</div>
      </div>
    </AuctionCard>
  );
};
